import { useState, useEffect, useMemo } from "react";
import {
    Box,
    Typography,
    TextField,
    Autocomplete,
    CircularProgress,
    Grid,
    Card,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import mail from '../assets/image/mail.png'
import cal from '../assets/image/calender.png'

const ContactUs = () => {

    const navigate = useNavigate();

    return (
        <div className="about-page">
            <div >

                <div className="pointer d-flex" onClick={() => { navigate('/') }}>
                    <img width="22" height="22" src="https://img.icons8.com/sf-ultralight-filled/25/00c062/chevron-left.png" alt="chevron-left" />
                    <p className="mb-0 ms-1 back">Back to Home</p>
                    </div>
                <Box textAlign="center" py={2} className="about-row">
                    <Typography variant="h3" component="h1" fontWeight="600" className="text-center ms-1 ab-text">
                        Contact Us
                    </Typography>

                    <Typography variant="p" marginTop={2}  className="text-left ms-1 cont-1">
                        Have questions about data accuracy, partnerships, or media inquiries?  <br /> We’d love to hear from you. Aysa is built on transparency, and that includes how you reach us.
                    </Typography>

                    <br/>

                      <Typography variant="p" marginTop={4}  color="#5F5F5F" className="con_text text-left copy_right ms-1">
                       We reply to all messages within 2 business days.
                    </Typography>

                 </Box>
            </div>
            <div className="contact-section about-section w-100 my-2 gap-5">
                <div className="border border-[#B7B7B7] rounded-2 p-3 contact-div">
                     <Typography variant="h5" textAlign="center" component="h1" fontWeight="600" className="text-left ms-1 con-head">
                        Email Us
                    </Typography>
                    <img src={mail} className="contact-img"/>
                    <p fontSize="18px" fontWeight="400" className="copy_right contact_box_p"> For general inquiries, data questions, or partnership requests. Reach out directly. We’ll get back to you as soon as possible.</p>

                    <button className="con_page_btn w-full">Email Us
                                               <img width="24" height="24" src="https://img.icons8.com/windows/32/FFFFFF/up-right-arrow.png" alt="up-right-arrow"/>

                    </button>
                </div>

                 <div className="border border-[#B7B7B7] rounded-2 p-3 contact-div">
                     <Typography variant="h5" textAlign="center" component="h1" fontWeight="600" className="text-left ms-1 con-head">
                        Schedule a Call
                    </Typography>
                     <img src={cal} className="contact-img"/>

                     <p fontSize="18px" fontWeight="400" className="copy_right contact_box_p">Want to talk about collaboration, or ethical data initiatives? <br/>  Book a short discovery call with our team.</p>
                     <button className="con_page_btn w-full">Book a Call
                        <img width="24" height="24" src="https://img.icons8.com/windows/32/FFFFFF/up-right-arrow.png" alt="up-right-arrow"/>
                     </button>
                </div>
                
                </div>
    </div>  
  );  
};  
  
export default ContactUs;
